export default {
  pending: 'Em processamento',
  closed: 'Concluído',
  canceled: 'Cancelado'
};
